import React from 'react'
import ProductDetails from '../components/product-details-page/Product.jsx';

export default function ProductPage() {
    return (
        <div>
            <ProductDetails />
        </div>
    )
}
